import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../utils";

export const uploadStudentExamRecording = createAsyncThunk('uploadStudentExamRecording', async ({ examId, chunks, navigate }) => {
    try {
        const formData = new FormData()
        formData.append('examId', examId)
        ;(chunks || []).forEach((item) => {
            if (item?.file) formData.append('chunks', item.file, item.name)
        })
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'student_exam_recording',
            data: formData,
            headers: { "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const uploadStudentExamRecordingSlice = createSlice({
    name: 'uploadStudentExamRecording',
    initialState: { data: null },
    extraReducers: (builder) => {
        builder.addCase(uploadStudentExamRecording.fulfilled, (state, action) => {
            if (action?.payload?.status === 200 && action?.payload?.data?.success !== false) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401 && !action.meta.arg?.silent) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403 && !action.meta.arg?.silent) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = null
            }
        });
    }
})

export default uploadStudentExamRecordingSlice.reducer;
